import { render, staticRenderFns } from "./SsoIndex.vue?vue&type=template&id=80ea7f74&"
import script from "./SsoIndex.vue?vue&type=script&lang=ts&"
export * from "./SsoIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports